import { Typography, Card } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { TicketDetail } from 'types';
import { requestform, sidebarMenuMessages } from 'messages';
import { GreenCheck, PrinterIcon } from 'assets';
import { GetTicketDetail, GetUserListInOrganization } from 'hooks/request-form';
import { DownOutlined } from '@ant-design/icons';

import defaultTicketDetail from '../../types/dto/request-form/request-form.dto';
import RequestDetailCreateFormInformation from '../request-form/RequestDetailCreateFormInformation';
import RequestStatusBar from '../request-form/RequestStatusBar';
import RequestDetailMainInformation from '../request-form/RequestDetailMainInformation';
import RequestDetailProcessing from '../request-form/RequestDetailProcessing';
import { useReactToPrint } from 'react-to-print';
import NormalTicket from '../print-ticket-detail/NormalTicket';
import PrintComponent from '../print-ticket/PrintTikcet';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import RequestDetailCmisTransferInformation from '../request-form/RequestDetailCmisTransferInformation';

interface ticketFromDetail {
  status?: string;
  ticketId: number;
  cancelDetailModal: () => void;
}

const FollowingRequestDetail: React.FC<ticketFromDetail> = ({ status, ticketId, cancelDetailModal }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const { requestDetail } = GetTicketDetail(ticketId);
  const [processingContent, setProcessingContent] = useState<string>('');
  const [requestItem, setRequestItem] = useState<TicketDetail>(defaultTicketDetail);

  const profile = useSelector((state: RootState) => state.users.userProfile);
  const { userInUnitCount, userInUnitList } = GetUserListInOrganization(
    profile?.organizationUnitId ? profile?.organizationUnitId : 0
  );

  const [ticketStatus, setTicketStatus] = useState(status);
  const [requestTicketId, setRequestTicketId] = useState<number>(ticketId);
  const [isHistory, setIsHistory] = useState(false);
  const [outageReasonId, setOutageReasonId] = useState<number>(requestDetail.additionalInfo.outageReasonId | 0);
  const [isPowerRestore, setIsPowerRestore] = useState<boolean>(false);
  const [datePowerRestore, setDatePowerRestore] = useState<Date>(
      new Date(requestDetail.additionalInfo.powerRestorationAt)
    );

  const changeTicketDetail = (newTicketId: number) => {
    setRequestTicketId(newTicketId);
    setTicketStatus(requestDetail?.status.code);
    setIsHistory(true);
  };

  useEffect(() => {
    if (requestDetail) {
      const formattedRequestDetail: TicketDetail = Object.assign({}, defaultTicketDetail, requestDetail);
      setRequestItem(formattedRequestDetail);
    }
  }, [requestDetail]);

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.requestTicket} {requestTicketId}
        </Typography.Text>
      }
      className='request-form-detail-card h-[95vh] text-center'
    >
      <div style={{ display: 'none' }}>
        <PrintComponent ref={contentRef}>
          <NormalTicket isHistory={isHistory} ticket={requestDetail} status={ticketStatus} ticketId={requestTicketId} />
        </PrintComponent>
      </div>

      <div className='flex w-full text-left'>
        <div className='w-[250px]'>
          <RequestDetailCreateFormInformation requestItem={requestItem} />
        </div>
        <section className='flex flex-col justify-between'>
          <section className='h-[calc(95vh-8rem) w-[870px] overflow-y-auto p-6 pt-4'>
            <section className='flex items-center justify-between'>
              <div className='w-4/5'>
                <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
                  {requestItem?.serviceType?.name ? requestItem.serviceType.name.split(' ').slice(0, 20).join(' ') : ''}
                </Typography.Text>
              </div>
              <button onClick={() => reactToPrintFn()} className='flex items-center space-x-2'>
                <PrinterIcon />
                <Typography.Text className='text-[16px]/[20px] text-[#1564E8]'>
                  {requestform.printTicket}
                </Typography.Text>
              </button>
            </section>

            <section>
              <Typography.Text
                className={`text-[14px]/[18px] ${requestItem?.isRequestMultipleTime ? 'text-[#D1131D]' : 'text-[#06A77D]'}`}
              >
                {requestItem?.isRequestMultipleTime
                  ? requestform.multiplleTimeRequest
                  : requestform.notMultiplleTimeRequest}
              </Typography.Text>
            </section>

            <section>
              {status && (
                <div className='pb-6'>
                  <RequestStatusBar status={status} />
                  {/* <RequestDetailCmisTransferInformation ticketDetail={requestItem} isHistory={isHistory} /> */}
                  {requestItem.cmisRequestId ? (
                    <button
                      // onClick={openCmisProcess}
                      className='mt-1 flex w-full justify-between rounded-[5px] bg-[#06A77D00] py-[11px] hover:bg-[#F5F5F7]'
                    >
                      <div className='flex space-x-1'>
                        <GreenCheck />
                        <Typography.Text className='text-[14px]/[18px] italic text-[#141414]'>
                          {requestform.cmisTranfered + requestItem.cmisRequestId}
                        </Typography.Text>
                      </div>{' '}
                    </button>
                  ) : (
                    <div className='mt-1 flex justify-between rounded-[5px] border border-[#D1131D] bg-[#06A77D00] px-4 py-[11px]'>
                      <div className='flex items-center space-x-2'>
                        <Typography.Text className='text-[14px]/[18px] font-semibold text-[#D1131D]'>
                          {requestform.cmisTransferFail}
                        </Typography.Text>{' '}
                        {/* <Typography.Text className='text-[14px]/[18px] text-[#141414]'>
                          <Dropdown overlay={menu} trigger={['click']}>
                            <div className='flex w-full cursor-pointer items-center justify-between space-x-2 border-[#EBEBED] bg-[#FFFFFF]'>
                              <Typography.Text className='text-[14px]/[18px]'>
                                {selectedOption?.name ? selectedOption?.name : requestform.typeCmisTicket}
                              </Typography.Text>
                              <DownOutlined className='h-2 w-[10px]' />
                            </div>
                          </Dropdown>
                        </Typography.Text>{' '} */}
                      </div>
                      {/* <button onClick={transferCmis}>
                        <Typography.Text className='text-[14px]/[18px] text-[#1564E8]'>
                          {requestform.tryAgainButton}
                        </Typography.Text>
                      </button> */}
                    </div>
                  )}
                </div>
              )}
            </section>

            <section className={`${status === 'completed' || isHistory ? 'h-[calc(90vh-16rem)] overflow-y-auto' : 'max-h-[calc(90vh-20rem)] overflow-y-auto'}`}>
              <RequestDetailMainInformation requestItem={requestItem} />
              <RequestDetailProcessing
                isHistory={isHistory}
                requestItem={requestItem}
                processingContent={processingContent}
                setProcessingContent={setProcessingContent}
                setOutageReasonId={setOutageReasonId}
                setIsPowerRestore={setIsPowerRestore}
                setDatePowerRestore={setDatePowerRestore}
              />
            </section>
          </section>
        </section>
      </div>
    </Card>
  );
};

export default FollowingRequestDetail;
